<template lang="html">
    <div class="wrapper">
        <Button @click.native="openWayFinder()" :title="button_text"></Button>
        <portal to="root">
            <modal :open="showWayfinder" :hero="{image:image}" no-padding
                   @closeModal="closeWayFinder">
                <div>
                    <h2>Bring me there</h2>
                    <Columns
                            :columns="[{ label: 'now', text: 'Current<br> Location' }, { label: 'hotel', text: `${address}<br> ${city}` }]"
                            :icon="'arrow-right'"
                    />

                    <Button v-for="(travelOption, provider, index) in travelOptions"
                            :key="`travel_provider_${provider}`"
                            :title="`${travelOption.title}`"
                            :subtext="`Takes ${travelOption.estimateTimeHuman}`"
                            :link="travelOption.deeplinkUrl"
                            icon-right="location"
                            :button-background="index === 0 ? 'dark' : 'transparent'"
                            :button-color="index === 0 ? 'light' : 'dark'"
                            :class="{'border--dark': index !== 0}"
                            target="_blank"
                    />
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Button from '@/components/partials/Button'
import Modal from '@/components/modals/Modal'
import Columns from '@/components/partials/Columns.vue'
import wayfindingservice from '@/services/WayfindingService'
import geoLocationService from '@/services/GeoLocationService'
import Picture from '@/components/image-caption/ImageCaption'

const statusOptions = {
  INIT: 'INIT',
  DONE: 'DONE',
  LOADING: 'LOADING',
  LOCATION_UNAVAILABLE: 'LOCATION_UNAVAILABLE',
  ROUTE_CALCULATION_FAILED: 'ROUTE_CALCULATION_FAILED',
}


export default {
  name: 'Wayfinder',
  components: {
    Button,
    Modal,
    Columns,
    Picture
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    destination: {
      type: String,
      default: ''
    },
    image: {
      type: [Object, Boolean],
      default: false
    },
    button_text: {
      type: String,
      default: ''
    },

    address: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    lat: {
      type: String,
      default: ''
    },
    lng: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      showWayfinder: false,
      travelOptions: {},
      status: statusOptions.INIT
    }
  },
  methods: {
    closeWayFinder() {
      this.showWayfinder = false
      this.travelOptions = {}
    },
    async openWayFinder () {
      this.travelOptions = {}
      this.showWayfinder = true
      let payload = {
        startLongitude: 4.893215,
        startLatitude: 52.372954,
        endLongitude: this.lng,
        endLatitude: this.lat,
      }
      try {
        const geoLocation = await geoLocationService.getCurrentLocation()
        payload.startLatitude = geoLocation.coords.latitude
        payload.startLongitude = geoLocation.coords.longitude

      } catch (err) {
        console.log('Could net get destination from device')
        console.error(err)
        alert('Can not get position')
        return false
      }

      const directions = await wayfindingservice.getTravelOptions(payload)
      // https://gist.github.com/diachedelic/0d60233dab3dcae3215da8a4dfdcd434
      this.travelOptions = directions
    }
  }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 0 0.9375rem;
    }
</style>
